export const SIRE_ESTADOS = Object.freeze({
  NO_INICIADO: "NO_INICIADO",
  PROPUESTA_DESCARGADA: "PROPUESTA_DESCARGADA",
  CONCILIANDO: "CONCILIANDO",
  CON_DIFERENCIAS: "CON_DIFERENCIAS",
  CONCILIADO: "CONCILIADO",
  LISTO_PARA_GENERAR: "LISTO_PARA_GENERAR",
  ARCHIVO_GENERADO: "ARCHIVO_GENERADO",
  ENVIANDO: "ENVIANDO",
  ENVIADO: "ENVIADO",
  PROCESANDO: "PROCESANDO",
  ACEPTADO: "ACEPTADO",
  OBSERVADO: "OBSERVADO",
  RECHAZADO: "RECHAZADO",
  CERRADO: "CERRADO",
  REABIERTO: "REABIERTO",
  CONCILIACION_DESACTUALIZADA: "CONCILIACION_DESACTUALIZADA",
  ERROR: "ERROR",
});

export const TRANSICIONES_PERMITIDAS = Object.freeze({
  [SIRE_ESTADOS.NO_INICIADO]: [SIRE_ESTADOS.PROPUESTA_DESCARGADA, SIRE_ESTADOS.ERROR],
  [SIRE_ESTADOS.PROPUESTA_DESCARGADA]: [SIRE_ESTADOS.CONCILIANDO, SIRE_ESTADOS.PROPUESTA_DESCARGADA, SIRE_ESTADOS.ERROR],
  [SIRE_ESTADOS.CONCILIANDO]: [SIRE_ESTADOS.CONCILIADO, SIRE_ESTADOS.CON_DIFERENCIAS, SIRE_ESTADOS.ERROR],
  [SIRE_ESTADOS.CON_DIFERENCIAS]: [SIRE_ESTADOS.CONCILIANDO, SIRE_ESTADOS.PROPUESTA_DESCARGADA, SIRE_ESTADOS.ERROR],
  [SIRE_ESTADOS.CONCILIADO]: [SIRE_ESTADOS.LISTO_PARA_GENERAR, SIRE_ESTADOS.CONCILIANDO, SIRE_ESTADOS.PROPUESTA_DESCARGADA, SIRE_ESTADOS.CONCILIACION_DESACTUALIZADA, SIRE_ESTADOS.ERROR],
  [SIRE_ESTADOS.LISTO_PARA_GENERAR]: [SIRE_ESTADOS.ARCHIVO_GENERADO, SIRE_ESTADOS.CONCILIADO, SIRE_ESTADOS.CONCILIACION_DESACTUALIZADA, SIRE_ESTADOS.ERROR],
  [SIRE_ESTADOS.ARCHIVO_GENERADO]: [SIRE_ESTADOS.ENVIANDO, SIRE_ESTADOS.ENVIADO, SIRE_ESTADOS.LISTO_PARA_GENERAR, SIRE_ESTADOS.CONCILIACION_DESACTUALIZADA, SIRE_ESTADOS.ERROR],
  [SIRE_ESTADOS.ENVIANDO]: [SIRE_ESTADOS.ENVIADO, SIRE_ESTADOS.PROCESANDO, SIRE_ESTADOS.ACEPTADO, SIRE_ESTADOS.OBSERVADO, SIRE_ESTADOS.RECHAZADO, SIRE_ESTADOS.ERROR],
  [SIRE_ESTADOS.ENVIADO]: [SIRE_ESTADOS.PROCESANDO, SIRE_ESTADOS.ACEPTADO, SIRE_ESTADOS.OBSERVADO, SIRE_ESTADOS.RECHAZADO, SIRE_ESTADOS.ERROR],
  [SIRE_ESTADOS.PROCESANDO]: [SIRE_ESTADOS.ACEPTADO, SIRE_ESTADOS.OBSERVADO, SIRE_ESTADOS.RECHAZADO, SIRE_ESTADOS.ERROR],
  [SIRE_ESTADOS.ACEPTADO]: [SIRE_ESTADOS.CERRADO],
  [SIRE_ESTADOS.OBSERVADO]: [SIRE_ESTADOS.PROPUESTA_DESCARGADA, SIRE_ESTADOS.CONCILIANDO, SIRE_ESTADOS.LISTO_PARA_GENERAR],
  [SIRE_ESTADOS.RECHAZADO]: [SIRE_ESTADOS.PROPUESTA_DESCARGADA, SIRE_ESTADOS.CONCILIANDO, SIRE_ESTADOS.LISTO_PARA_GENERAR, SIRE_ESTADOS.ARCHIVO_GENERADO],
  [SIRE_ESTADOS.CERRADO]: [SIRE_ESTADOS.REABIERTO],
  [SIRE_ESTADOS.REABIERTO]: [SIRE_ESTADOS.PROPUESTA_DESCARGADA, SIRE_ESTADOS.CONCILIANDO, SIRE_ESTADOS.LISTO_PARA_GENERAR, SIRE_ESTADOS.CERRADO],
  [SIRE_ESTADOS.CONCILIACION_DESACTUALIZADA]: [SIRE_ESTADOS.CONCILIANDO, SIRE_ESTADOS.PROPUESTA_DESCARGADA],
  [SIRE_ESTADOS.ERROR]: [SIRE_ESTADOS.NO_INICIADO, SIRE_ESTADOS.PROPUESTA_DESCARGADA, SIRE_ESTADOS.CONCILIANDO],
});

export const esTransicionValida = (estadoActual, nuevoEstado) => {
  if (estadoActual === nuevoEstado) return true;
  const permitidas = TRANSICIONES_PERMITIDAS[estadoActual] || [];
  return permitidas.includes(nuevoEstado);
};
